import SortableListComponent from "../sortable-list/sortable-list.component";
import MultiSelectComponent from "./multi-select.component";

let uniqueInstance = 1;

/**
 * Sortable Multi-select Component
 * - Utilizing `MultiSelectComponent` & `SortableListComponent`
 * 
 * @author CV Leong
 */
export default function SortableMultiSelectComponent() {

  const COMPONENT_DEFAULT_ID = `sortable-multi-select-${uniqueInstance++}`;

  let _dataItemKey;
  let _dataItemValue;
  let _itemKeyOrder = [];
  const _defaultHandler = () => { };

  const _onChange = (onChange, itemList, itemKeyOrder) => {
    _itemKeyOrder = itemKeyOrder;
    onChange(itemList, itemKeyOrder);
  }

  const _onSelect = (onSelect, onChange, itemList) => {
    _itemKeyOrder.push(itemList.at(-1)?.[_dataItemKey]);

    // To check if `_itemKeyOrder` is in stale state. 
    // It happens when `selectedItems` was updated outside of `SortableMultiSelectComponent` component. 
    let itemKeyList = itemList.map(i => i[_dataItemKey]);
    if (!compareArrays(itemKeyList, _itemKeyOrder)) {
      _itemKeyOrder = itemKeyList;
    }

    onChange(itemList, _itemKeyOrder);
    onSelect(itemList);
  }

  const compareArrays = function(arr1 = [], arr2 = []) {
    if (arr1.length !== arr2.length) return false;

    return arr1.every(i => arr2.includes(i))
  }

  return {
    oninit: ({ attrs: {
      itemKey = 'code',
      itemValue = 'name',
    } }) => {
      _dataItemKey = itemKey;
      _dataItemValue = itemValue;
    },
    view: ({ attrs: {
      id = COMPONENT_DEFAULT_ID,
      items,
      itemKey = 'code',
      itemValue = 'name',
      multiSelectAttrs,
      onChange = _defaultHandler,
      onSelect = _defaultHandler,
      required,
      selectedItems,
      sortableListAttrs,
    } }) => {
      return [
        m(MultiSelectComponent, {
          id,
          isButton: true,
          items,
          itemKey,
          itemValue,
          onSelect: (itemList) => _onSelect(onSelect, onChange, itemList),
          required,
          selectedItems,
          ...multiSelectAttrs,
        }),
        m(SortableListComponent, {
          items: selectedItems,
          itemKey,
          itemValue,
          onChange: (itemList, itemKeyOrder) => _onChange(onChange, itemList, itemKeyOrder),
          ...sortableListAttrs,
        }),
      ]
    }
  }
}
